module.exports = __webpack_public_path__ + "img/collection-memoireRingsColored@2x.0018bfc.webp";